/* DEPARTMENTS */
export const GET_ACT_SHIPPING = 'GET_ACT_SHIPPING';
export const GET_ACT_SHIPPING_SUCCESS = 'GET_ACT_SHIPPING_SUCCESS';
export const GET_ACT_SHIPPING_FAIL = 'GET_ACT_SHIPPING_FAIL';

export const ADD_ACT_SHIPPING = 'ADD_ACT_SHIPPING';
export const ADD_ACT_SHIPPING_SUCCESS = 'ADD_ACT_SHIPPING_SUCCESS';
export const ADD_ACT_SHIPPING_FAIL = 'ADD_ACT_SHIPPING_FAIL';

export const UPDATE_ACT_SHIPPING = 'UPDATE_ACT_SHIPPING';
export const UPDATE_ACT_SHIPPING_SUCCESS = 'UPDATE_ACT_SHIPPING_SUCCESS';
export const UPDATE_ACT_SHIPPING_FAIL = 'UPDATE_ACT_SHIPPING_FAIL';

export const DELETE_ACT_SHIPPING = 'DELETE_ACT_SHIPPING';
export const DELETE_ACT_SHIPPING_SUCCESS = 'DELETE_ACT_SHIPPING_SUCCESS';
export const DELETE_ACT_SHIPPING_FAIL = 'DELETE_ACT_SHIPPING_FAIL';

export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
